import React, {FC} from 'react'

import cn from 'classnames/bind'

import s from './LayoutPaystub.module.scss'
import LayoutDefault from '../LayoutDefault'

const cx = cn.bind(s)

interface ILayoutPaystubProps {
	className?: string
}

const LayoutPaystub: FC<ILayoutPaystubProps> = ({className, children}) => {
	return (
		<LayoutDefault hasMenuStub={false} className={cx('wrapper', className)}>
			{children}
		</LayoutDefault>
	)
}

LayoutPaystub.displayName = 'LayoutPaystub'

export default LayoutPaystub
